var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsAutomationsEventsPayments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31,
    fill: "#E0EEFF",
    stroke: "#FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0072FF",
    className: "background"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 8c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V10c0-1.105.895-2 2-2h20zm0 2H6v12h20V10zm-4 5c1.657 0 3 1.343 3 3s-1.343 3-3 3c-.536 0-1.05-.142-1.499-.4-.45.258-.964.4-1.501.4-1.657 0-3-1.343-3-3s1.343-3 3-3c.536 0 1.05.142 1.499.4.45-.258.964-.4 1.501-.4zm0 2c-.25 0-.483.091-.663.252l-.086.086c-.162.183-.251.414-.251.662 0 .207.062.402.175.566l.075.095c.189.215.458.339.75.339.552 0 1-.448 1-1s-.448-1-1-1zm-3 0c-.552 0-1 .448-1 1s.448 1 1 1l.062-.002.061-.005.044-.009-.041-.123c-.042-.138-.073-.279-.094-.423l-.024-.217L19 18c0-.222.024-.44.071-.652l.055-.21.041-.123-.044-.007L19 17z",
    transform: "translate(16 16)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsAutomationsEventsPayments);
export default __webpack_public_path__ + "static/media/illustrations-automations-events-payments.0eef0997.svg";
export { ForwardRef as ReactComponent };